'use strict'

let $modal

export function init() {
    $modal = $('.')
}

export function initInScope($scope) {
    const
        $resetBtn   = $scope.find('.js-strex-general__reset-btn');

    
}